import { DEFAULT_QUOTE_NUMBER_FORMAT, type QuoteNumberFormat } from '@/config/quoteNumber';

/**
 * Human-friendly, sortable and obviously sequential: `QT-2026-000001`.
 *
 * Customers read quote numbers aloud on the phone, so the format favours
 * legibility over compactness. The prefix is per-business (a detailer might
 * use `CD`), the rest is house style.
 */
export function formatQuoteNumber(
  sequence: number,
  prefix?: string,
  format: QuoteNumberFormat = DEFAULT_QUOTE_NUMBER_FORMAT,
  date: Date = new Date(),
): string {
  const segments = [prefix?.trim() || format.prefix];
  if (format.includeYear) segments.push(String(date.getFullYear()));
  segments.push(String(Math.max(1, Math.trunc(sequence))).padStart(format.padding, '0'));
  return segments.join(format.separator);
}

/** Next number for a business, without mutating it. */
export function nextQuoteNumber(
  currentSequence: number,
  prefix?: string,
  format?: QuoteNumberFormat,
): { sequence: number; number: string } {
  const sequence = Math.max(0, Math.trunc(currentSequence)) + 1;
  return { sequence, number: formatQuoteNumber(sequence, prefix, format) };
}
